<template>
  <div class="flowListPage"  v-if="workflowCode">
    <div class="flow-pic-layout" ref="processBody" :style="boxStyle">
      <div class="process-table" v-if="drawNodeData.length > 0" :style="tableStyle">
        <div class="process-tr" >
          <div class="process-td" :class="{isActive:startActive}">
            <div class="name">开始</div>
          </div>
        </div>
        <div class="process-tr"  v-for="(item,index) in drawNodeData" :key="'level'+index"  >
          <div
            class="process-td"
            :class="{ isActive: step.isActive, isReject: step.isReject}"
            v-for="(step,j) in item.children"
            :key="'step'+j"
          >
            <div class="name">{{step.nodeName}}</div>
          </div>
        </div>
        <div class="process-tr" >
          <div class="process-td" :class="{isActive:endActive}">
            <div class="name">结束</div>
          </div>
        </div>
      </div>
      <canvas id="drawArrow" :width="box.width" :height="box.height"></canvas>
    </div>
  </div>
</template>
<script>
/* eslint-disable */

import {
  getCanvasWidth,
  getCanvasHeight,
  drawFlowChart,
  nodeData,
  getSelectParentCode
} from "@/utils/drawFlowChart";
export default {
  name: "flowList",
  props: {
    workflowCode: { type: String }
  },
  data() {
    return {
      keyWord: "",
      chartData: {},
      tasklogData: [],
      drawNodeData: [],
      printWorkflowList:[],
      box: {
        //画布尺寸对象
        width: "",
        height: ""
      },
      drawing: "",
      context: "", //canvas对象
      drawFlag: false,
      drawConfig: {
        //流程图基础参数配置对象
        yShift: 0, //y轴偏移
        stepWidth: 90, //步骤宽度
        stepHeight: 30, //步骤高度
        spacing: 60 //层级之间间隔
      }
    };
  },
  mounted() {
    if (this.workflowCode) {
      this.keyWord = this.workflowCode;
      this.getTask();
      this.getTaskInfo();
      this.setBoxSize();
    }
  },
  methods: {
   
    getTask() {
      let _this = this;
      _this.$api.flowPath.flow
        .taskLog(_this.keyWord)
        .then(res => {
          //查询流程操作记录-陈国贵
          if (res.code == "1") {
           
            _this.tasklogData = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTaskInfo() {
      let _this = this;
      _this.$api.flowPath.flow
        .getTaskInfo(_this.keyWord)
        .then(res => {
          //查询流程操作记录-陈国贵
          if (res.code == "1") {
            _this.getChartCode(res.data.chartCode, res.data.chartVersion);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getChartCode(code, chartVersion) {
      let _this = this;
      _this.$api.flowPath.flow
        .getChartCode(code, chartVersion)
        .then(res => {
          if (res.code == "1") {
            _this.chartData = res.data;
            _this.drawFlowArrow();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    drawFlowArrow() {
      let _this = this;
      this.tasklogData = this.tasklogData.filter(item => item.event != "NEXT"); //排除下一步记录
      for (let task of this.tasklogData) {
        let codeName = task.currentNode == "_end" ? "end" : task.currentNode;
        let index = _this.chartData.nodes.findIndex(
          item => item.nodeCode == codeName
        );

        if (index >= 0) {
          this.chartData.nodes[index].isActive = true;
          // this.chartData.nodes[index].isReject = true;

          this.chartData.nodes[index].isReject = task.buttonCode == "reject";
        }
      }

      this.box.height = getCanvasHeight(this.drawConfig, this.chartData);
      this.box.width = getCanvasWidth(this.drawConfig, this.chartData);
      this.$refs.processBody.style.height = 300;
      _this.$nextTick(() => {
        this.drawing = document.getElementById("drawArrow");
        if (this.drawing.getContext) {
          this.context = this.drawing.getContext("2d"); //取得2D上下文对象
          drawFlowChart(
            this.drawConfig,
            this.chartData,
            this.context,
            this.box,
            _this.flowState == "pass"
          );
          this.drawNodeData = nodeData;
        }
      });
    },
    setBoxSize() {
      //设置画布尺寸

      this.box.width = this.$refs.processBody.offsetWidth;
      this.box.height = this.$refs.processBody.offsetHeight;
    }
  },
  computed: {
    startActive() {
      //开始步骤标识
      if (this.chartData.nodes) {
        let arr = this.chartData.nodes.filter(
          item => item.type == "start" && item.isActive
        );
        return arr.length > 0;
      } else {
        return false;
      }
    },
    endActive() {
      //结束步骤标识
      if (this.chartData.nodes) {
        let arr = this.chartData.nodes.filter(
          item => item.type == "end" && item.isActive
        );
        return arr.length > 0;
      } else {
        return false;
      }
    },
    boxStyle() {
      const { box } = this;
      return {
        height: box.height > 0 ? `${box.height + 55}px` : "auto"
      };
    },
    tableStyle() {
      const { box } = this;
      let Window_W = document.body.offsetWidth;
      return {
        width: box.width > Window_W ? `${box.width}px` : `${Window_W}px`
      };
    }
  },
  watch: {
    workflowCode: function(value) {
      if (value) {
        this.keyWord = value;
        this.getTask();
        this.getTaskInfo();
        this.setBoxSize();
      }
    }
  }
};
</script>
<style lang="less">
.flowListPage {
  width: 100%;
  background-color: #fff;
  padding-top: 8px;
  z-index: 999;

  .flow-pic-layout {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    -webkit-transform: translate(-50%);
    -moz-transform: translate(-50%);

    // width: 100%;
    // height: 100%;
    box-sizing: border-box;
    margin-top: 10px;
    overflow-x: scroll;
  }
  .process-table {
    position: absolute;
    left: 0;
    right: 5px;
    top: 0;
    bottom: 5px;
    z-index: 2;
    background: transparent;
  }
  .process-tr {
    text-align: center;
    .process-td {
      width:120Px;
      display: inline-block;
      padding: 0 3px;
      margin: 0 5px;
      line-height: 30Px;
      text-align: center;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      background-color: #fff;
      color: #333;
      font-size: 11Px;
      z-index: 998;
    }
    .isActive {
      background: #2581d6;
      color: #fff;
    }
    .isReject {
      background: #f00;
      color: #fff;
    }
  }
}
/** 平板 **/

@media only screen and (min-width: 1024px) {
  .flow-pic-layout{
    height: 700px!important;
  }
.process-tr {
    margin-bottom: 60px;
  }
}
@media only screen and (min-width: 540px) and (max-width: 1024px) {
.process-tr {
    margin-bottom: 60px;
  }
}

/** 手机 **/
@media only screen and (min-width: 411px) and (max-width: 540px) {
  .process-tr {
    margin-bottom: 59px;
  }
}
@media only screen and (min-width: 375px) and (max-width: 410px) {
  .process-tr {
    margin-bottom: 58px;
  }
}
@media only screen and (min-width: 321px) and (max-width: 374px){
  .process-tr {
    margin-bottom: 58px;
  }
}
@media only screen and (max-width: 320px) {
  .process-tr {
    margin-bottom: 65px;
  }
}
</style>